import fetchOptions from "./fetchOptions";
import store from "../redux/store/userStore";
import {errorVehicles} from "../redux/Actions/UserDataActions";

export const vehicleService = {

    getVehiclesForProduct: async (productId) => {
        let enrolledVehicles = null;

        const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/vehicle/product/${productId}/enroll`,
            fetchOptions("GET")
        );

        const data = await response.json();

        if (response.ok) {
            enrolledVehicles = data
        } else {
            store.dispatch(errorVehicles(data));
            throw new Error(data);
        }

        return enrolledVehicles;
    },

    getVehicleImage: async (vin,modelYear) => {

        if (vin !== null && modelYear !== null ) {
            return await
                fetch(`${process.env.REACT_APP_BACKEND_URL}/vehicle/image`, {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Content-Type": "application/json",
                        "auth-token": window?.fma?.["CATBundle"]?.["access_token"] ?? null,
                        "application-id": process.env.REACT_APP_APPLICATION_ID,
                    },
                    body: JSON.stringify({
                        vin: vin,
                        angle: 5,
                        year: modelYear
                    })
                });
        }
    },
};